export function SettingsGroup({ title, children, className = '' }) {
  return (
    <section className={className}>
      {title ? (
        <h2 className="px-1 pb-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground/80">
          {title}
        </h2>
      ) : null}
      <div className="overflow-hidden rounded-2xl border border-border bg-card">{children}</div>
    </section>
  );
}
